(function () {
  function initLocator(root) {
    const searchInput = root.querySelector('[data-wl-locator-search]');
    const countEl = root.querySelector('[data-wl-locator-count]');
    const directionsBtn = root.querySelector('[data-wl-locator-directions]');
    const cityWrap = root.querySelector('[data-wl-locator-cities]');
    const emptyEl = root.querySelector('[data-wl-locator-empty]');
    const cards = Array.from(root.querySelectorAll('[data-wl-locator-card]'));
    const mapEl = root.querySelector('[data-wl-locator-map]');
    const mapFallback = root.querySelector('[data-wl-locator-map-fallback]');

    const stores = cards.map((card) => ({
      card,
      name: card.dataset.name || '',
      city: card.dataset.city || '',
      area: card.dataset.area || '',
      address: card.dataset.address || '',
      lat: parseFloat(card.dataset.lat),
      lng: parseFloat(card.dataset.lng),
    }));

    let searchTerm = '';
    let selectedCity = 'All';
    let activeStore = stores[0] || null;
    let map = null;
    let markers = new Map();
    let mapsApi = null;

    function directionsUrl(store) {
      return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${store.name}, ${store.address}`)}`;
    }

    function filteredStores() {
      let list = stores;
      if (selectedCity !== 'All') {
        list = list.filter((s) => s.city.toLowerCase() === selectedCity.toLowerCase());
      }
      const term = searchTerm.trim().toLowerCase();
      if (term) {
        list = list.filter(
          (s) =>
            s.city.toLowerCase().includes(term) ||
            s.area.toLowerCase().includes(term) ||
            s.name.toLowerCase().includes(term) ||
            s.address.toLowerCase().includes(term)
        );
      }
      return list;
    }

    function setActiveStore(store) {
      activeStore = store;
      stores.forEach((s) => s.card.classList.toggle('is-active', s === store));
      if (directionsBtn && store) {
        directionsBtn.href = directionsUrl(store);
      }
      if (map && store && !Number.isNaN(store.lat) && !Number.isNaN(store.lng)) {
        map.panTo({ lat: store.lat, lng: store.lng });
      }
      updateMarkerStyles();
    }

    function render() {
      const visible = filteredStores();
      const visibleSet = new Set(visible);

      stores.forEach((s) => {
        s.card.hidden = !visibleSet.has(s);
      });

      if (emptyEl) emptyEl.hidden = visible.length !== 0;

      if (countEl) {
        countEl.textContent = `${visible.length} store${visible.length === 1 ? '' : 's'} found`;
      }

      if (!activeStore || !visibleSet.has(activeStore)) {
        setActiveStore(visible[0] || null);
      } else if (directionsBtn && activeStore) {
        directionsBtn.href = directionsUrl(activeStore);
      }

      syncMarkers(visible);
    }

    cards.forEach((card, i) => {
      card.addEventListener('click', () => setActiveStore(stores[i]));
    });

    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        searchTerm = e.target.value;
        render();
      });
    }

    if (cityWrap) {
      cityWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-wl-city]');
        if (!btn) return;
        selectedCity = btn.dataset.wlCity;
        cityWrap.querySelectorAll('[data-wl-city]').forEach((el) => {
          el.classList.toggle('is-active', el === btn);
        });
        render();
      });
    }

    // --- Optional Google Maps enhancement ---
    function updateMarkerStyles() {
      if (!mapsApi) return;
      markers.forEach((marker, store) => {
        const isActive = store === activeStore;
        marker.setIcon({
          path: mapsApi.SymbolPath.CIRCLE,
          scale: isActive ? 12 : 8,
          fillColor: isActive ? '#1A6FE0' : '#0F2C4D',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeWeight: isActive ? 3 : 2,
        });
        marker.setZIndex(isActive ? 999 : 1);
      });
    }

    function syncMarkers(visible) {
      if (!map || !mapsApi) return;
      const visibleSet = new Set(visible);
      markers.forEach((marker, store) => {
        if (!visibleSet.has(store)) {
          marker.setMap(null);
          markers.delete(store);
        }
      });
      visible.forEach((store) => {
        if (Number.isNaN(store.lat) || Number.isNaN(store.lng)) return;
        if (markers.has(store)) return;
        const marker = new mapsApi.Marker({
          position: { lat: store.lat, lng: store.lng },
          map,
          title: store.name,
        });
        marker.addListener('click', () => setActiveStore(store));
        markers.set(store, marker);
      });
      updateMarkerStyles();
    }

    function initMap() {
      if (!mapEl || !window.google || !window.google.maps) return;
      mapsApi = window.google.maps;
      const center =
        activeStore && !Number.isNaN(activeStore.lat)
          ? { lat: activeStore.lat, lng: activeStore.lng }
          : { lat: 22.3072, lng: 73.1898 };
      map = new mapsApi.Map(mapEl, {
        center,
        zoom: 14,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      });
      if (mapFallback) mapFallback.hidden = true;
      syncMarkers(filteredStores());
    }

    const apiKey = root.dataset.mapsKey;
    if (apiKey && mapEl) {
      const callbackName = '__wlLocatorInit_' + Math.random().toString(36).slice(2);
      window[callbackName] = initMap;
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=${callbackName}`;
      script.async = true;
      script.defer = true;
      script.onerror = () => {
        if (mapFallback) {
          mapFallback.hidden = false;
          mapFallback.textContent = "Map couldn't load.";
        }
      };
      document.head.appendChild(script);
    }

    render();
  }

  document.querySelectorAll('[data-wl-locator]').forEach(initLocator);
})();
